import type { User } from '@libs/contexts';
import { Menu } from '@mui/material';
import { useState } from 'react';
import { CompanyMenuItem } from './CompanyMenuItem';

interface CompanyMenuProps {
  user: User;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export function CompanyMenu(props: CompanyMenuProps) {
  const { user, anchorEl, setAnchorEl } = props;
  const [currentValid, setCurrentValid] = useState<number | null>(null);

  const onClose = () => {
    setCurrentValid(null);
    setAnchorEl(null);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="company-menu"
      open={Boolean(anchorEl)}
      onClose={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transitionDuration={0}
      MenuListProps={{
        sx: { width: '250px' },
        disablePadding: true,
      }}
    >
      {user.availableCompanies.map((c, i) => (
        <CompanyMenuItem
          key={c.code}
          index={i}
          setCurrentValid={setCurrentValid}
          currentValid={currentValid}
          companyCode={c.code}
          companyName={c.name}
          regions={c.availableRegions}
          onClose={onClose}
        />
      ))}
    </Menu>
  );
}
